module.exports = __webpack_public_path__ + "basic4.png?960a39358c60ca15be077584bb973c7c";